import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

export default class CrawlExtractSellingPriceService extends BaseService {
  crawlExtractSellingPrice = (data) => {
    return this.axios.post(API_ENDPOINTS.CRAWL_EXTRACT_SELLING_PRICE, data);
  }

  getCrawlExtractSellingPrice = () => {
    return this.axios.get(API_ENDPOINTS.GET_CRAWL_EXTRACT_SELLING_PRICE);
  }
}
